import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.license-management.purchase-license', {
        url: '/purchase',
        component: 'purchaseLicense',
        resolve: {
            licenseTiers
        },
    });
}

/** @ngInject */
function licenseTiers(LicenseManagementService, $stateParams) {
    return LicenseManagementService.getLicenseTiers($stateParams.companyId);
}


// WEBPACK FOOTER //
// ./src/portal/states/company/license-management/purchase-license/purchase-license.state.js